import React, { useContext, useEffect, useState } from 'react';
import ScoreFieldView from '../view/ScoreFieldView';
import { FormPreviewContext } from '../../engine/FormPreviewEngine';
import { FormContext } from '../FormContext';

const ScoreFieldEngine = ({
  internalId,
  value,
  endpointType,
  ...fieldProps // for future development, know whe have this
}) => {
  const formPreviewContextProps = useContext(FormPreviewContext);
  const isFormPreview =
    formPreviewContextProps && formPreviewContextProps.isFormPreview;
  const { getSubmissionsId, isSubmitting } = useContext(FormContext);

  const [valueToShow, setValueToShow] = useState(value || 0);

  useEffect(() => {
    if (isSubmitting && isSubmitting.current) {
      return;
    }
    const checkForSubmissionId = async () => {
      if (endpointType === 'a') {
        const submissionId = await getSubmissionsId(false);
        if (submissionId) {
          setValueToShow(value);
        } else {
          setValueToShow(value || 0);
        }
      }
    };
    checkForSubmissionId();
  }, [endpointType, getSubmissionsId, setValueToShow, value]);

  const viewProps = {
    value: valueToShow,
    internalId,
    isFormPreview,
    readOnly: true
  };

  return <ScoreFieldView {...viewProps} />;
};

export default ScoreFieldEngine;
